import { t } from '@lingui/macro';
import modalActions from '../../containers/modal-container/modal-actions';
import { NEW_TOTAL } from '../../containers/participation/config/certificate-constants';
import Resources from '../../helpers/resources';

export const CERTIFICATES_DOWNLOAD_REQUESTED =
    'CERTIFICATES_DOWNLOAD_REQUESTED';
export const CERTIFICATES_DOWNLOAD_COMPLETED =
    'CERTIFICATES_DOWNLOAD_COMPLETED';
export const GEM_COUNTS_RETRIEVED = 'GEM_COUNTS_RETRIEVED';

const certificatesDownloadRequested = () => ({
    type: CERTIFICATES_DOWNLOAD_REQUESTED
});

const certificatesDownloadCompleted = () => ({
    type: CERTIFICATES_DOWNLOAD_COMPLETED
});

function getCertificateFilename({
    className = '',
    certificatesCount = '',
    certificateType = ''
}) {
    const i18n = window.i18n;
    const name = `${className}_${certificatesCount}_${certificateType}`;
    return i18n._(t`Filename - Certificates - ${name}`);
}

async function onSuccess({
    dispatch,
    url,
    certificateType,
    certificatesCount,
    className,
    fileNameOverride
}) {
    dispatch(certificatesDownloadCompleted());
    const authToken = Resources.env.authToken;
    const downloadUrl = `${url}&authToken=${authToken}`;
    const response = await window.fetch(downloadUrl);
    const blob = await response.blob();

    const a = window.document.createElement('a');
    const objectUrl = window.URL.createObjectURL(blob);

    a.href = objectUrl;
    let certificateFileName =
        fileNameOverride ||
        getCertificateFilename({
            className,
            certificatesCount,
            certificateType
        });
    certificateFileName = certificateFileName.replace(/\./g, '-');
    a.download = certificateFileName;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
}

function newCertificatesDownload(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        return Resources.downloadNewCertificates
            .get()
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        ...payload
                    });
                }
            });
    };
}
function pastCertificatesDownload(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        return Resources.downloadPastCertificates
            .get()
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        ...payload
                    });
                }
            });
    };
}

function newCertificatesDownloadByType(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        const {
            certificatesCount,
            certificateTypeName,
            className,
            fileNameOverride
        } = payload;
        return Resources.downloadNewCertificatesByType
            .get({ type: payload.type })
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        certificatesCount,
                        certificateType: certificateTypeName,
                        className,
                        fileNameOverride
                    });
                }
            });
    };
}
function pastCertificatesDownloadByType(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        const {
            certificatesCount,
            certificateTypeName,
            className,
            fileNameOverride
        } = payload;
        return Resources.downloadPastCertificatesByType
            .get({ type: payload.type })
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        certificatesCount,
                        certificateType: certificateTypeName,
                        className,
                        fileNameOverride
                    });
                }
            });
    };
}

function pastCertificatesDownloadStudentByType(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        const { userProfileId, fileNameOverride } = payload;
        return Resources.downloadPastCertificatesStudentByType
            .get({ userProfileId })
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        fileNameOverride
                    });
                }
            });
    };
}

function newCertificatesDownloadStudentByType(payload) {
    return (dispatch) => {
        dispatch(certificatesDownloadRequested());
        dispatch(modalActions.closeModal());
        const {
            userId,
            type,
            fileNameOverride,
            certificateTypeName,
            certificatesCount,
            className,
            gemTypes
        } = payload;
        if (type === NEW_TOTAL.type) {
            return Resources.downloadNewCertificatesStudent
                .get({ userId })
                .withParams(payload)
                .raw()
                .send()
                .then((response) => {
                    if (response.status === 200) {
                        onSuccess({
                            dispatch,
                            url: response.verb.url,
                            certificateType: certificateTypeName,
                            className,
                            certificatesCount,
                            fileNameOverride
                        });
                    }
                });
        }
        return Resources.downloadNewCertificatesStudentByType
            .get({ userId, type, gemTypes })
            .withParams(payload)
            .raw()
            .send()
            .then((response) => {
                if (response.status === 200) {
                    onSuccess({
                        dispatch,
                        url: response.verb.url,
                        fileNameOverride,
                        certificateType: certificateTypeName,
                        certificatesCount,
                        className
                    });
                }
            });
    };
}

function getGemCountsByType(payload) {
    return (dispatch) =>
        Resources.getGemCounts
            .get()
            .withParams(payload)
            .send()
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GEM_COUNTS_RETRIEVED,
                        payload: response.data
                    });
                }
            });
}

export default {
    newCertificatesDownload,
    pastCertificatesDownload,
    newCertificatesDownloadByType,
    pastCertificatesDownloadByType,
    pastCertificatesDownloadStudentByType,
    newCertificatesDownloadStudentByType,
    getGemCountsByType
};



// WEBPACK FOOTER //
// ./components/certificates/certificates-actions.js